import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import BlockUi from 'react-block-ui';
import { FormattedMessage } from 'react-intl';

import { NimaLoadingIndicator } from '@Common/nimaLoading';
import { styles } from './style';
import messages from '@Locales/config/common/messages';

/*
 * O texto visivel continua sendo o `message` do BlockUi; o indicador entra sem
 * rotulo proprio (so o sr-only) para nao duplicar o anuncio.
 */
const LoadingComponent = props => {
  const { message, classes } = props;

  return (
    <Grid container>
      <Grid item xs={12}>
        <BlockUi
          tag={'div'}
          message={message || <FormattedMessage {...messages.loadingConfig} />}
          className={classes.blockUi}
          blocking
          loader={<NimaLoadingIndicator size="md" tone="auto" showLabel={false} />}
        />
      </Grid>
    </Grid>
  );
};

LoadingComponent.propTypes = {
  message: PropTypes.string
};

LoadingComponent.defaultProps = {
  message: null
};

export default withStyles(styles)(LoadingComponent);
